import React from "react";
import { Button, Modal, Typography } from "@mui/material";

import { ErrorModalWrapper } from "./styled";

const ErrorModal = ({ errors, open, setOpen }) => {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ErrorModalWrapper>
        <div className="content">
          <Typography className="content_item" align="center">
            {Object.entries(errors).map(([key, value]) => (
              <div key={key}>{value || ""}</div>
            ))}
          </Typography>
          <Button className="close_btn" onClick={() => setOpen(false)}>
            繼續填寫
          </Button>
        </div>
      </ErrorModalWrapper>
    </Modal>
  );
};
export default ErrorModal;
